import styled, { css } from 'styled-components';
import { Flex, isNotDarkThemeMixin, Heading, isMobileStyleMixin, InlineAlert } from '@amzn/storm-ui';

const PageHeaderWrapper = /*#__PURE__*/styled(Flex).attrs({
  gap: 'small',
  alignItems: 'normal'
}).withConfig({
  componentId: "sc-storm-ui-40026394__sc-hhysh1-0"
})(["width:100%;box-sizing:border-box;margin:0;padding:", ";background-color:", ";border-block-end:1px solid ", ";", ";"], ({
  theme
}) => `${theme.spacing.small.default} ${theme.spacing.base.default}`, ({
  theme
}) => theme.pageHeader.backgroundColor, ({
  theme
}) => theme.elevation.borderColor.subtle, isNotDarkThemeMixin(css(["box-shadow:", ";"], ({
  theme
}) => theme.elevation.shadow.card)));
const TitleTextWrapper = /*#__PURE__*/styled(Heading).withConfig({
  componentId: "sc-storm-ui-40026394__sc-hhysh1-1"
})(["display:flex;font-weight:", ";"], ({
  theme
}) => theme.font.weight.regular);
const TitleText = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-storm-ui-40026394__sc-hhysh1-2"
})(["font-weight:", ";", " ", ""], ({
  theme
}) => theme.font.weight.bold, isMobileStyleMixin(css(["word-break:break-word;"])), props => props.hasPrefix && css(["padding-inline-start:", ";", ""], ({
  theme
}) => theme.spacing.xxsmall.default, isMobileStyleMixin(css(["padding-inline-start:", ";"], ({
  theme
}) => theme.spacing.xxxxsmall.mobile))));
const AttributesAndActionsWrapper = /*#__PURE__*/styled(Flex).attrs({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 'base xxlarge',
  flexWrap: 'wrap'
}).withConfig({
  componentId: "sc-storm-ui-40026394__sc-hhysh1-3"
})(["", " ", ""], isMobileStyleMixin(css(["flex-direction:column;align-items:start;gap:", ";"], ({
  theme
}) => theme.spacing.medium.mobile)), ({
  hasActionsWithNoAttributes
}) => hasActionsWithNoAttributes && css(["justify-content:flex-end;"]));

// Needed to be able to pass the ref into Flex component
const Wrapper = /*#__PURE__*/styled(Flex).attrs({
  // eslint-disable-next-line id-length
  as: 'div'
}).withConfig({
  componentId: "sc-storm-ui-40026394__sc-hhysh1-4"
})([""]);
const ActionsWrapper = /*#__PURE__*/styled(Wrapper).withConfig({
  componentId: "sc-storm-ui-40026394__sc-hhysh1-5"
})(["", ""], ({
  isWrapped
}) => !isWrapped && css(["margin-inline-start:auto;"]));
const InlineError = /*#__PURE__*/styled(InlineAlert).withConfig({
  componentId: "sc-storm-ui-40026394__sc-hhysh1-6"
})(["width:100%;margin-top:", ";display:flex;align-items:center;justify-content:", ";", " > span{flex:none;}"], ({
  theme
}) => theme.spacing.base.default, ({
  isRightAligned
}) => isRightAligned ? 'end' : 'start', isMobileStyleMixin(css(["justify-content:start;margin-top:", ";"], ({
  theme
}) => theme.spacing.xsmall.mobile)));

export { AttributesAndActionsWrapper as A, InlineError as I, PageHeaderWrapper as P, TitleTextWrapper as T, Wrapper as W, TitleText as a, ActionsWrapper as b };
//# sourceMappingURL=PageHeader.styles-DKUNRW-4.js.map
